import Images from "../../../assets/images";
import styles from "./InvoicesTable.module.scss";
import useInvoicesTable from "./useInvoicesTable";
import secondaryComponents from "..";
import { RoutedModal } from "../../common";

const InvoiceTable = ({
  invoices: invoicesList,
  refetchSupplierInvoices,
  gotoPage,
  supplierDetails,
}) => {
  const { instance, isUpdateCredit, selectedInvoice, setIsUpdateCredit } =
    useInvoicesTable({ invoicesList: invoicesList?.data });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;
  return (
    <div className={styles.invoiceTable}>
      <>
        <secondaryComponents.TableHelper
          getTableProps={getTableProps}
          getTableBodyProps={getTableBodyProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
        >
          <div className="text-center mt-5 mb-5">
            <img src={Images.supplierEmptyState} width="250px" alt="" />
            <h4 className="font-weight-semibold text-center mt-4">
              You have no invoices
            </h4>
          </div>
        </secondaryComponents.TableHelper>

        <secondaryComponents.Pagination
          totalPageNumber={invoicesList?.meta?.last_page}
          handlePageClick={(value) => gotoPage(value?.selected + 1)}
          currentPage={invoicesList?.meta?.current_page}
        />

        <RoutedModal
          isActive={isUpdateCredit}
          closeModal={() => setIsUpdateCredit(false)}
          headerTitle="Update Invoice Credit"
          width={650}
          style={{ height: "auto" }}
        >
          <secondaryComponents.CreditForm
            invoiceDetails={selectedInvoice}
            handleFetchInvoice={refetchSupplierInvoices}
            supplierDetails={supplierDetails}
            closeWidget={() => setIsUpdateCredit(false)}
          />
        </RoutedModal>
      </>
    </div>
  );
};
export default InvoiceTable;
